import { render, staticRenderFns } from "./configuration-templates-synoptic-templates-grid.vue?vue&type=template&id=a0c9bdc0&scoped=true&"
import script from "./configuration-templates-synoptic-templates-grid.ts?vue&type=script&lang=ts&"
export * from "./configuration-templates-synoptic-templates-grid.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-templates-synoptic-templates-grid.scss?vue&type=style&index=0&id=a0c9bdc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c9bdc0",
  null
  
)

export default component.exports